module.exports = __webpack_public_path__ + "static/media/table_column_name_dropdown_selection.f6d5e17e.png";